module.exports = __webpack_public_path__ + "static/img/burlington1.d907671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/burlington1.jpg
// module id = 72
// module chunks = 9